import DataSource from "devextreme/data/data_source";
import { loadFn, Params } from "shared/component/dxf-map/dxf-map";
import { client } from "shared/helpers/client";


export const getBankAccounts=(params: Params)=> {
  return client<any[]>('/OwnerBooking/GetAllBanksData')
}

export const myBankAccountSource = new DataSource({
    key:"id",
    load:loadFn(getBankAccounts)
  })